import { ServiceStatus } from '@app/services/enums/service-status.enum';

export class BaseService {
    name: string;
    serviceTypeId: string;
    description: string;
    transactionId: string;
    active: boolean;
    status: ServiceStatus;

    constructor(partial: Partial<BaseService>) {
        this.name = partial?.name;
        this.serviceTypeId = partial?.serviceTypeId;
        this.description = partial?.description;
        this.transactionId = partial?.transactionId;
        this.active = partial?.active;
        this.status = partial?.status;
    }

    public isReadyToSubmit(): boolean {
        return this.status === ServiceStatus.ReadyToSubmit;
    }

    public isInfoRequested(): boolean {
        return this.status === ServiceStatus.InfoRequested;
    }

    public isNotInfoRequested(): boolean {
        return this.status !== ServiceStatus.InfoRequested;
    }

    public isSubmitted(): boolean {
        return this.status === ServiceStatus.Submitted;
    }

    public isSubmittedOrInactive(): boolean {
        return this.isNotActive() || this.isSubmitted();
    }

    public isNotSubmitted(): boolean {
        return this.status !== ServiceStatus.Submitted;
    }

    public isActive(): boolean {
        return !!this.active;
    }

    public isNotActive(): boolean {
        return !this.active;
    }
}
